import React from 'react';
import { CheckIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Mein Arzt war sprachlos. Meine Knochendichte hatte sich verbessert und ich hatte sichtbar Muskelmasse aufgebaut – mit 59 Jahren!',
    name: 'Ingrid M.',
    age: 59,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8XMy6kTExJbSv4csXHewVQ/Screenshot_2025-10-14_at_12.46.41.png'
  }, {
    quote: 'Nach 5 Tagen: mehr Energie. Nach 14 Tagen: sichtbar straffere Oberarme. Nach 8 Wochen: -3,2kg und das beste Körpergefühl seit meinen 30ern.',
    name: 'Daniela K.',
    age: 48,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8kGfoLbhVPE3wzUaE2d3EK/Screenshot_2025-10-14_at_12.47.06.png'
  }, {
    quote: 'Meine Tochter fragte: "Mama, hast du dir was machen lassen?" Mein Gesicht sah straffer aus, meine Arme definierter, mein Bauch flacher.',
    name: 'Petra W.',
    age: 64,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tbWqJFLwURhqUQJv6aDBjG/Screenshot_2025-10-14_at_12.47.54.png'
  }];
  return <section className="py-12 bg-white" data-id="element-300">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-301">
        <div className="text-center mb-10" data-id="element-302">
          <h3 className="text-4xl font-bold text-gray-800 mb-2" data-id="element-303">
            Echte Frauen, echte Ergebnisse, echte Transformationen
          </h3>
          <p className="text-gray-600" data-id="element-304">54.000+ glückliche Kundinnen</p>
        </div>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-305">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-306">
              <div className="flex items-center mb-4" data-id="element-307">
                <div className="flex" data-id="element-308">
                  {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-4 h-4 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" data-id="element-309">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-310" />
                    </svg>)}
                </div>
              </div>
              <div className="h-48 rounded mb-4 overflow-hidden" data-id="element-311">
                <img src={testimonial.image} alt={`eve nutrition Protein von ${testimonial.name}`} className="w-full h-full object-cover" data-id="element-312" />
              </div>
              <p className="italic text-gray-700 mb-4" data-id="element-313">"{testimonial.quote}"</p>
              <div className="flex items-center" data-id="element-314">
                <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-700 font-bold text-sm mr-3" data-id="element-315">
                  {testimonial.name.charAt(0)}
                </div>
                <p className="text-gray-600" data-id="element-316">
                  {testimonial.name}, {testimonial.age} Jahre
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}